// extracted by mini-css-extract-plugin
var _1 = "Typography_editablePlaceholder__890f5";
var _2 = "Typography_fluid__4d559";
var _3 = "Typography_heading__390cc";
var _4 = "Typography_hint__1bb96";
var _5 = "Typography_large__b4efc";
var _6 = "Typography_link__56500";
var _7 = "Typography_medium__ec6c5";
var _8 = "Typography_mini__2fac6";
var _9 = "Typography_placeholder__37eab";
var _a = "Typography_pointer__9469d";
var _b = "Typography_root__1061b";
var _c = "Typography_weight-bold__a256e";
var _d = "Typography_weight-medium__bc571";
var _e = "Typography_weight-regular__a1812";
var _f = "Typography_weight-semi__97678";
var _10 = "Typography_xmini__c8975";
export { _1 as "editablePlaceholder", _2 as "fluid", _3 as "heading", _4 as "hint", _5 as "large", _6 as "link", _7 as "medium", _8 as "mini", _9 as "placeholder", _a as "pointer", _b as "root", _c as "weight-bold", _d as "weight-medium", _e as "weight-regular", _f as "weight-semi", _10 as "xmini" }
